import { Box, Stack } from '@mui/material'
import moment from 'moment'
import ReactApexChart from 'react-apexcharts'
import { COLORS } from 'styles/colors'
import ChartLegend from 'ui/charts/legends/ChartLegend'
import { TypographyPrimary14Bold } from 'ui/typography/TypographyPrimary14Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

import { localizationApexCharts } from 'utils'

interface PsvDynamicHeaderProps {
	timestamp: number[]
	psv_value: number[] | number
	norm_psv_value: number[] | number
}

const PsvWidgetChart = (props: PsvDynamicHeaderProps) => {
	const { timestamp, psv_value, norm_psv_value } = props
	const validDistributedFood = Array.isArray(psv_value)
		? psv_value
		: typeof psv_value === 'number'
			? [psv_value]
			: []

	const normValue = Array.isArray(norm_psv_value)
		? norm_psv_value[norm_psv_value.length - 1]
		: norm_psv_value

	const isEmptyData = validDistributedFood.length === 0
	const normSeries = validDistributedFood.map(() => normValue)
	const series: any = [
		{
			name: 'ПСВ',
			data: validDistributedFood,
		},
		{
			name: 'Норма ПСВ',
			data: normSeries,
		},
	]

	const options: any = {
		mask: false,
		colors: [COLORS.health, '#00B050'],
		chart: {
			locales: localizationApexCharts(),
			defaultLocale: 'ru',
			zoom: {
				enabled: false,
			},
			height: 250,
			type: 'line',
			toolbar: {
				show: false,
			},
		},
		markers: {
			size: [0, 0],
			colors: ['#fff', '#fff'],
			strokeColors: [COLORS.health, '#00B050'],
			strokeWidth: 2,
			hover: {
				size: 5,
			},
		},
		stroke: {
			width: [2, 1],
			curve: 'straight',
			dashArray: [0, 12],
		},
		title: {
			style: {
				fontSize: '12px',
				fontFamily: 'Montserrat',
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: '15px',
				color: '#7F7F84',
			},
		},

		dataLabels: {
			enabled: false,
		},
		grid: {
			strokeDashArray: 4,
			borderColor: '#E0E0E0',
			show: true,
			xaxis: { lines: { show: true } },
			yaxis: { lines: { show: true } },
		},
		xaxis: {
			crosshairs: {
				show: true,
				opacity: 1,
				position: 'back',
				stroke: {
					width: 1,
					dashArray: 0,
				},
			},
			type: 'datetime',
			tooltip: {
				enabled: false,
			},
			labels: {
				datetimeUTC: false,
				style: {
					fontSize: '12px',
					fontFamily: 'Montserrat',
					fontStyle: 'normal',
					fontWeight: 400,
					lineHeight: '15px',
					color: '#7F7F84',
				},
				datetimeFormatter: {
					year: 'yyyy',
					month: 'MM',
					day: 'dd.MM',
					hour: 'HH:mm',
				},
				formatter: (val: number) => moment(val).format('DD.MM'),
				rotate: 0,
			},
			categories: timestamp,
		},
		yaxis: {
			min: 0,
			max: Math.ceil(Math.max(...validDistributedFood, normValue) / 8) * 8,
			tickAmount: 2,
			labels: {
				style: {
					fontSize: '12px',
					fontFamily: 'Montserrat',
					fontStyle: 'normal',
					fontWeight: 400,
					lineHeight: '15px',
					color: '#7F7F84',
				},
				formatter: (value: number) => {
					const rounded = Number(value.toFixed(1))
					return Number.isInteger(rounded)
						? rounded.toFixed(0)
						: rounded.toFixed(1)
				},
			},
		},
		tooltip: {
			enabled: false,

			// tooltip: {
			// 	fixed: true,
			// 	custom: ({ series, seriesIndex, dataPointIndex, w }) => {
			// 		const timeValue = moment(
			// 			w.config.xaxis.categories[dataPointIndex],
			// 		).format('D.MM.YY')
			// 		const perfectPoint = validDistributedFood[dataPointIndex]

			// 		return `<div
			// 		style='width:max-content; height:auto; background-color: #fff; border-radius:12px; border: hidden; box-shadow: 0px 0px 16px 0px rgba(4, 6, 6, 0.16); position: relative'>
			// 		<div style='padding:16px 8px; border: none;'>
			// 			<div style='display: flex; flex-direction: column; gap:4px'>

			// 				<div style='display:flex; flex-direction:row; align-items: center; gap:4px'>
			// 					<span style='width:12px; height:12px; border-radius: 50%; background-color: ${
			// 						COLORS.health
			// 					};'></span>
			// 					<p style='font-weight: 600; font-size: 16px; color: #000; margin: 0px'>${perfectPoint}</p>
			// 					<p style='font-weight: 400; font-size: 12px; color: #7F7F84; margin: 0px'>кг/голову</p>
			// 				</div>

			// 				<div>
			// 					<p style='font-weight: 400; font-size: 12px; color: #7F7F84; margin: 0px'>${timeValue}</p>
			// 				</div>
			// 			</div>
			// 		</div>
			// 	</div>`
			// 	},
		},
		legend: {
			show: false,
		},
	}
	const descriptionForLegend = [
		{
			color: COLORS.health,
			description: 'ПСВ',
		},
		{
			color: COLORS.success,
			description: 'Норма ПСВ',
		},
	]
	return (
		<Box
			sx={{
				width: '100%',
				height: 146,
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			{isEmptyData ? (
				<Stack
					direction={'column'}
					justifyContent={'center'}
					alignItems={'center'}
					gap={'4px'}
				>
					<TypographyPrimary14Bold sx={{ color: COLORS.icon }}>
						Нет данных
					</TypographyPrimary14Bold>
					<TypographySecondary14>
						Нет данных, соответствующих заданным условиям
					</TypographySecondary14>
				</Stack>
			) : (
				<>
					<Stack direction='row'>
						<TypographySecondary>кг/голову</TypographySecondary>
					</Stack>
					<ReactApexChart
						id={'feedConsumption'}
						options={{ ...options, chart: { ...options.chart, height: 146 } }}
						series={series}
						type='line'
						height={146}
						width='100%'
					/>
					<ChartLegend initialLegends={descriptionForLegend} />
				</>
			)}
		</Box>
	)
}

export default PsvWidgetChart
